import { render, staticRenderFns } from "./RulesInfobox.vue?vue&type=template&id=6ca17ea6&scoped=true"
import script from "./RulesInfobox.vue?vue&type=script&lang=js"
export * from "./RulesInfobox.vue?vue&type=script&lang=js"
import style0 from "./RulesInfobox.vue?vue&type=style&index=0&id=6ca17ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca17ea6",
  null
  
)

export default component.exports